import { useAppSelector } from '../../store/hooks';
export const useIsAuthed = () => useAppSelector(state => ({
  isAuthed: !!state.auth.profile && ['ready', 'refreshing'].includes(state.auth.accessStatus),
}));
